module.exports = {
	"id": "",
	"name": "Loading...",
	"location": {
		"position": {
			"latitude": 43.039003,
			"longitude": -87.912486
		}
	},
	"arb": {
		"rating": {
			"average": null,
			"personalized": null
		},
		"comments": 0,
		"review_count": 0,
		"reviewers": 0,
		"reviews": [],
		"my_reviews": {}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Place/mock.json
// module id = 1090
// module chunks = 0